import React, { PureComponent } from 'react'
// import PropTypes from 'prop-types'
import {
  Layout,
  Menu,
  Avatar,
  Badge,
  Input,
  Tooltip
} from 'antd';
import {
  // ClusterOutlined,
  DashboardOutlined,
  BellOutlined,
  LogoutOutlined,
  TeamOutlined,
  CloseOutlined,
  // HomeOutlined,
  // HeartOutlined,
  // TeamOutlined,
  // SnippetsOutlined,
  // MailOutlined,
  // GroupOutlined,
  LineChartOutlined,
  // MenuUnfoldOutlined,
  // MenuFoldOutlined,
  UserOutlined,
  // GlobalOutlined,
  // DropboxOutlined,
  // BugOutlined,
  // LoginOutlined,
  SettingOutlined,
  // BankOutlined,
  // FolderOpenOutlined,
  // SmileOutlined,
  // DatabaseOutlined,
  // ToolOutlined,
  // LayoutOutlined,
  // UsergroupAddOutlined,
  // ShoppingOutlined,
  DiffOutlined,
  // SwapOutlined,
  // ShoppingCartOutlined,
  // ArrowsAltOutlined,
  CarOutlined,
  // DollarOutlined,
  InfoCircleOutlined,
  CopyOutlined,
  SafetyCertificateOutlined,
  HistoryOutlined,
  LockOutlined
} from '@ant-design/icons';
// import Cookies from 'js-cookie';
// import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import 'react-perfect-scrollbar/dist/css/styles.css';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Helmet } from "react-helmet";

import { Link } from "react-router-dom";

import { connect } from 'react-redux';
import { setConfig, ajaxViewHandler } from "../store/actions";

import Config from '../Config';
import { doLogout } from '../utils/sessionWS';

const { SubMenu } = Menu;
const { Sider } = Layout;

const configClass = {
  apiUrl: {
    sider: ""
  }
}

class AdminSider extends PureComponent {
  config;

  constructor(props) {
    super(props);
    this.config = new Config();
    this.state = {
      cariMenu: "",
      activeMenu: [],
    }
  }

  handleLogout = () => {
    // Logout terpusat — pakai socket device milik AdminLayout (registry),
    // tidak lagi membuka WebSocket baru di sini.
    doLogout(this.props.setConfig);
  }

  componentDidMount() {
    //this.getInfoSidebar();
  }

  setAllActive() {
    this.setState({
      activeMenu: ["menumaster", "mn_pegawai", "mn_pengaturan", "mn_info", "mn_transaksi", "mn_laporan"],
    })
  }

  cariMenu(keyword, source) {
    const temps = source.split(" ");
    const temps2 = keyword.split(" ");
    let result = false;
    for (let i = 0; i < temps.length; i++) {
      for (let x = 0; x < temps2.length; x++) {
        if (temps[i].toLowerCase().includes(temps2[x].toLowerCase())) {
          result = true;
          break;
        }
      }
    }
    return result;
  }

  onMenuExpand = (listOpen) => {
    if (listOpen.length == 1) {
      // console.log("kode1", listOpen);
      this.setState({
        // activeMenu: listOpen[0],
        activeMenu: listOpen,
      });
    } else {
      // console.log("kode2", listOpen[listOpen.length - 1]);
      this.setState({
        // activeMenu: listOpen[listOpen.length - 1],
        activeMenu: listOpen,
      });
    }
    // if (selectionToolIsDisable) {
    //   const openedKeyIndex = openKeys.indexOf('menu1')
    //     if (openedKeyIndex != -1) {
    //         const _openKeys = [...openKeys]
    //         _openKeys.splice(openedKeyIndex, 1)
    //         setOpenKeys(_openKeys)
    //     }
    // } else {
    //     setOpenKeys([...openKeys, 'menu1'])
    // }
    // this.setState({
    //   defaultOpenKeys: ["mn_task"]
    // })
  };


  notifyMe(msg) {
    // Let's check if the browser supports notifications
    if (!("Notification" in window)) {
      alert("This browser does not support desktop notification");
    }

    // Let's check whether notification permissions have already been granted
    else if (Notification.permission == "granted") {
      // If it's okay let's create a notification
      var notification = new Notification(msg);
    }

    // Otherwise, we need to ask the user for permission
    else if (Notification.permission != "denied") {
      Notification.requestPermission().then(function (permission) {
        // If the user accepts, let's create a notification
        if (permission == "granted") {
          var notification = new Notification(msg);
        }
      });
    }

    // At last, if the user has denied notifications, and you
    // want to be respectful there is no need to bother them any more.
  }

  async getInfoSidebar() {
    this.props.ajaxViewHandler('get', configClass.apiUrl.sider)
      .then(() => {
        const data = this.props.responseMsg.results[0];
        if (this.props.isSuccess) {
          /*
          this.setState({
            logoDesa: data.logo!=null&&data.logo!=''?data.logo:process.env.PUBLIC_URL + "/logo_landscape.png",
            namaDesa: data.name,
          });
          */
        } else {
          /*
          this.setState({
            namaDesa: 'gagal menampilkan info desa',
          });
          */
        }
      }).catch((response) => {
        /*
        this.setState({
            namaDesa: 'gagal menampilkan info desa',
        });
        */
      });
  }

  render() {
    return (
      <>
        <Helmet>
          <title>{"admin | " + (this.props.nama != undefined ? this.props.nama : this.config.get_site_info().name)}</title>
        </Helmet>
        <Sider
          breakpoint="lg"
          width={this.props.isMobile ? '100%' : 256}
          trigger={null}
          collapsible
          collapsed={this.props.collapsed}
          className="sider"
        >
          <div className="brand">
            <div className="logo">
              {this.props.collapsed == false
                ?
                <img alt="logo" src={this.config.get_site_info().logo_landscape} />
                :
                <img alt="logo" src={this.config.get_site_info().logo} />
              }
            </div>
            {this.props.isMobile && (
              <div
                className="sider-close-btn"
                onClick={() => this.props.setConfig({ collapsed: true })}
              >
                <CloseOutlined />
              </div>
            )}
          </div>
          <Input
            allowClear
            placeholder="Cari Menu"
            style={{
              borderLeft: 0,
              borderRight: 0,
              width: "100%",
              paddingLeft: 30,
              paddingRight: 20,
              textTransform: "none"
            }}
            onChange={(e) => {
              this.setState({
                cariMenu: e.target.value
              }, () => {
                if (this.state.cariMenu == "") {
                  this.setState({ activeMenu: [] })
                } else {
                  this.setAllActive();
                }
              })
            }}
          />
          <PerfectScrollbar className="sidebar-menu-scroll">
          <Menu
            mode="inline"
            className="sidebar"
            openKeys={this.state.activeMenu}
            defaultOpenKeys={this.state.activeMenu}
            onOpenChange={this.onMenuExpand}
            onClick={() => {
              if (this.props.isMobile) {
                this.props.setConfig({ collapsed: true });
              }
            }}
          >
            <Menu.Item key="dashboard">
              <DashboardOutlined style={{ marginRight: 10 }} />
              <Link to="/admin/index">
                {(!this.props.collapsed && 'Dashboard')}
              </Link>
            </Menu.Item>
            {/* Log Aktivitas Saya DIPINDAH ke ikon topbar (AdminHeader.jsx,
                sejajar Pengumuman/Panduan) - tidak lagi di sidebar, lihat
                diskusi rencana 2026-10-17. */}
            {/* Log Aktivitas User - khusus admin/superadmin (level_user<=2),
                SAMA PERSIS pengecekan backend IsAdminOrSuperadmin - sengaja
                top-level jg (bukan akses.xxx), krn backend endpoint ini
                TIDAK PERNAH cek hak_akses, cuma level_user. */}
            {(this.props.level_user || 3) <= 2 &&
              <>
                {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Log Aktivitas User Admin SIGNAL EPAHARI Huma Betang")) &&
                  <Menu.Item key="activitylog-admin">
                    <HistoryOutlined style={{ marginRight: 10 }} />
                    <Link to="/admin/activitylog/kelola">
                      {(!this.props.collapsed && 'Log Aktivitas User')}
                    </Link>
                  </Menu.Item>
                }
              </>
            }
            {(this.props.akses == null ||
              (this.props.akses != undefined && this.props.akses.master == true &&
                (this.state.cariMenu == "" ||
                  this.cariMenu(this.state.cariMenu, "master tanda tangan negara Merek tipe jenis kendaraan bahan bakar warna pekerjaan kepemilikan Layanan Dealer Payment Golongan Warna Plat Fungsi NJKB Import NJKB kabupaten rekening Data IWKBU Gudang Notice Kendaraan Pencarian Kendaraan"))
              )
              &&
              <SubMenu
                key="menumaster"
                title={
                  <span>
                    <DiffOutlined />
                    <span>Master</span>
                  </span>
                }
              >
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.master_negara == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "negara")) &&
                      <Menu.Item key="negara"><Link to="/admin/negara">Negara</Link></Menu.Item>
                    }
                  </>
                )}
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.master_merek == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "merek")) &&
                      <Menu.Item key="merek"><Link to="/admin/merek">Merek</Link></Menu.Item>
                    }
                  </>
                )}
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.master_kendaraan == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "kendaraan")) &&
                      <Menu.Item key="kendaraan"><Link to="/admin/kendaraan">Kendaraan</Link></Menu.Item>
                    }
                  </>
                )}
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.master_jenis_kendaraan == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "jenis kendaraan")) &&
                      <Menu.Item key="jenis_kendaraan"><Link to="/admin/jenis-kendaraan">Jenis Kendaraan</Link></Menu.Item>
                    }
                  </>
                )}
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.master_Tipe == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "tipe")) &&
                      <Menu.Item key="tipe"><Link to="/admin/tipe">Tipe</Link></Menu.Item>
                    }
                  </>
                )}
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.pengaturan_njkb == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "NJKB")) &&
                      <Menu.Item key="njkb"><Link to="/admin/njkb">NJKB</Link></Menu.Item>
                    }
                  </>
                )}
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.master_layanan == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Layanan")) &&
                      <Menu.Item key="layanan"><Link to="/admin/layanan">Layanan</Link></Menu.Item>
                    }
                  </>
                )}
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.master_gudang_notice == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Gudang Notice")) &&
                      <Menu.Item key="gudang_notice"><Link to="/admin/gudang-notice">Gudang Notice</Link></Menu.Item>
                    }
                  </>
                )}
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.master_mac_address == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Perangkat MAC Address")) &&
                      <Menu.Item key="master_mac_address"><Link to="/admin/mac-address">Perangkat / MAC Address</Link></Menu.Item>
                    }
                  </>
                )}
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.master_warna == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "warna")) &&
                      <Menu.Item key="warna"><Link to="/admin/warna">Warna</Link></Menu.Item>
                    }
                  </>
                )}
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.master_warna_plat == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Warna Plat")) &&
                      <Menu.Item key="warna_plat"><Link to="/admin/warna-plat">Warna Plat</Link></Menu.Item>
                    }
                  </>
                )}
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.master_bahan_bakar == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "bahan bakar")) &&
                      <Menu.Item key="bahan_bakar"><Link to="/admin/bahan-bakar">Bahan Bakar</Link></Menu.Item>
                    }
                  </>
                )}
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.master_fungsi == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Fungsi")) &&
                      <Menu.Item key="fungsi"><Link to="/admin/fungsi">Fungsi</Link></Menu.Item>
                    }
                  </>
                )}
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.master_payment == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Payment")) &&
                      <Menu.Item key="payment"><Link to="/admin/payment">Payment</Link></Menu.Item>
                    }
                  </>
                )}
                {/* Golongan & Data IWKBU dipindah ke grup menu "Jasa Raharja" (2026-10-03) */}
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.master_tanda_tangan == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "tanda tangan skpd")) &&
                      <Menu.Item key="tanda_tangan"><Link to="/admin/tanda_tangan">Tanda Tangan SKPD</Link></Menu.Item>
                    }
                  </>
                )}
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.master_ttd_laporan == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "tanda tangan laporan")) &&
                      <Menu.Item key="tanda_tangan_laporan"><Link to="/admin/tanda_tangan_laporan">Tanda Tangan Laporan</Link></Menu.Item>
                    }
                  </>
                )}
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.master_kepemilikan == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "kepemilikan")) &&
                      <Menu.Item key="kepemilikan"><Link to="/admin/kepemilikan">Kepemilikan</Link></Menu.Item>
                    }
                  </>
                )}
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.master_pekerjaan == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "pekerjaan")) &&
                      <Menu.Item key="pekerjaan"><Link to="/admin/pekerjaan">Pekerjaan</Link></Menu.Item>
                    }
                  </>
                )}
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.master_dealer == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Dealer")) &&
                      <Menu.Item key="dealer"><Link to="/admin/dealer">Dealer</Link></Menu.Item>
                    }
                  </>
                )}
                {/* Khusus Superadmin (level_user === 1), bukan akses.master_kabupaten - data rekening kabupaten sensitif */}
                {this.props.level_user === 1 &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "kabupaten rekening")) &&
                      <Menu.Item key="kabupaten"><Link to="/admin/kabupaten">Kabupaten</Link></Menu.Item>
                    }
                  </>
                }
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.pengaturan_njkb == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Import NJKB")) &&
                      <Menu.Item key="njkb-import"><Link to="/admin/njkb-import">Import NJKB</Link></Menu.Item>
                    }
                  </>
                )}
              </SubMenu>
            )}

            {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.pegawai == true &&
              (this.state.cariMenu == "" ||
                this.cariMenu(this.state.cariMenu, "Jabatan Waktu Operasional Upt Bidang Pegawai")
              )
            ) &&
              <SubMenu
                key="mn_pegawai"
                title={
                  <span>
                    <UserOutlined />
                    <span>Pegawai</span>
                  </span>
                }
              >
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.pegawai_jabatan == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Jabatan")) &&
                      <Menu.Item key="jabatan">
                        <Link to="/admin/jabatan">
                          Jabatan
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}

                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.waktu_operasional == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Waktu Operasional")) &&
                      <Menu.Item key="waktu_operasional">
                        <Link to="/admin/waktu-operasional">
                          Waktu Operasional
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}

                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.pegawai_upt == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Upt")) &&
                      <Menu.Item key="upt">
                        <Link to="/admin/upt">
                          Upt
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.pegawai_bidang == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Bidang")) &&
                      <Menu.Item key="bidang">
                        <Link to="/admin/bidang">
                          Bidang
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.pegawai_pegawai == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Pegawai")) &&
                      <Menu.Item key="pegawai">
                        <Link to="/admin/pegawai">
                          Pegawai
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}

              </SubMenu>
            )}
            {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.pengaturan == true &&
              (this.state.cariMenu == "" ||
                this.cariMenu(this.state.cariMenu, "Pengaturan Diskon Umum SWDKLLJ Adm. STNK Adm. TNKB Denda Pkb Denda SWDKLLJ Notice Tanda Tangan Laporan Printer Target Pendapatan Migrasi Legacy Notice")
              )
            ) &&
              <SubMenu
                key="mn_pengaturan"
                title={
                  <span>
                    <SettingOutlined />
                    <span>Pengaturan</span>
                  </span>
                }
              >
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.pengaturan_dikon == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Diskon")) &&
                      <Menu.Item key="diskon">
                        <Link to="/admin/pengaturan/diskon">
                          Diskon
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}

                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.pengaturan_reward_diskon == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Reward Tepat Waktu")) &&
                      <Menu.Item key="reward-tepat-waktu">
                        <Link to="/admin/pengaturan/reward-tepat-waktu">
                          Reward Tepat Waktu
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}

                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.pengaturan_hari_libur == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Hari Libur")) &&
                      <Menu.Item key="pengaturan-hari-libur">
                        <Link to="/admin/pengaturan/hari-libur">
                          Hari Libur
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}

                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.pengaturan_umum == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Umum")) &&
                      <Menu.Item key="umum">
                        <Link to="/admin/pengaturan/umum">
                          Umum
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}

                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.pengaturan_swdkllj == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "SWDKLLJ")) &&
                      <Menu.Item key="swdkllj">
                        <Link to="/admin/pengaturan/swdkllj">
                          SWDKLLJ
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.pengaturan_adm_stnk == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Adm. STNK")) &&
                      <Menu.Item key="admstnk">
                        <Link to="/admin/pengaturan/admstnk">
                          Adm. STNK
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.pengaturan_adm_tnkb == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Adm. TNKB")) &&
                      <Menu.Item key="admtnkb">
                        <Link to="/admin/pengaturan/admtnkb">
                          Adm. TNKB
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.pengaturan_denda_pkb == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Denda Pkb")) &&
                      <Menu.Item key="denda_pkb">
                        <Link to="/admin/pengaturan/denda-pkb">
                          Denda Pkb
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.pengaturan_denda_swdkllj == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Denda SWDKLLJ")) &&
                      <Menu.Item key="denda_swdkllj">
                        <Link to="/admin/pengaturan/denda-swdkllj">
                          Denda SWDKLLJ
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}
                {/* {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.pengaturan_notice == true) && */}
                {(this.props.akses == null || (this.props.waktu_akses.is_bypass == true || (this.props.akses != undefined && this.props.akses.pengaturan_notice == true)) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Notice")) &&
                      <Menu.Item key="pengaturan_notice">
                        <Link to="/admin/pengaturan/notice">
                          Notice
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}

{(this.props.akses == null || (this.props.akses != undefined && this.props.akses.pengaturan_printer == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Printer")) &&
                      <Menu.Item key="pengaturan_printer">
                        <Link to="/admin/pengaturan/printer">
                          Printer
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}

                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.pengaturan_target_pendapatan == true)) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Target Pendapatan")) &&
                      <Menu.Item key="target_pendapatan">
                        <Link to="/admin/pengaturan/target-pendapatan">
                          Target Pendapatan
                        </Link>
                      </Menu.Item>
                    }
                  </>
                }

                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.pengaturan_migrasi_legacy_notice == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Migrasi Legacy Notice")) &&
                      <Menu.Item key="pengaturan_migrasi_legacy_notice">
                        <Link to="/admin/pengaturan/migrasi-legacy-notice">
                          Migrasi Legacy Notice
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}

              </SubMenu>
            )}
            {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.informasi == true &&
              (this.state.cariMenu == "" ||
                this.cariMenu(this.state.cariMenu, "Informasi Kendaraan Cari Data KBM Cari Kendaraan Migrasi")
              )
            ) &&
              <SubMenu
                key="mn_info"
                title={
                  <span>
                    <InfoCircleOutlined />
                    <span>Informasi</span>
                  </span>
                }
              >
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.informasi_informasi_kendaraan == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Informasi Kendaraan")) &&
                      <Menu.Item key="informasi_kendaraan">
                        <Link to="/admin/informasi/informasi-kendaraan">
                          Informasi Kendaraan
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.informasi_cari_kendaraan == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Cari Kendaraan")) &&
                      <Menu.Item key="cari_kendaraan">
                        <Link to="/admin/informasi/cari-kendaraan">
                          Cari Kendaraan
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.informasi_migrasi == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Migrasi")) &&
                      <Menu.Item key="migrasi">
                        <Link to="/admin/informasi/migrasi">
                          Migrasi
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}
              </SubMenu>
            )}
            {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.transaksi == true &&
              (this.state.cariMenu == "" ||
                this.cariMenu(this.state.cariMenu, "Pendaftaran Penetapan Pembayaran Surat Keterangan Fiskal Batal Notice Histori Notice Jasaraharja IWKBU blokir")
              )
            ) &&
              <SubMenu
                key="mn_transaksi"
                title={
                  <span>
                    <CarOutlined />
                    <span>Transaksi</span>
                  </span>
                }
              >
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.blokir == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Blokir")) &&
                      <Menu.Item key="blokir">
                        <Link to="/admin/transaksi/blokir">
                          Blokir
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}
                {(this.props.akses == null || (this.props.waktu_akses.is_bypass == false && (this.props.akses != undefined && this.props.akses.transaksi_pendaftaran_eri == true)) &&
                // {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.transaksi_pendaftaran_eri == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Pendaftaran ERI")) &&
                      <Menu.Item key="pdftrn_eri">
                        <Link to="/admin/transaksi/pendaftaran-eri">
                          Pendaftaran dari ERI
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}
                {(this.props.akses == null || (this.props.waktu_akses.is_bypass == false && (this.props.akses != undefined && this.props.akses.transaksi_penetapan_eri == true)) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Penetapan Eri")) &&
                      <Menu.Item key="penetapan_eri">
                        <Link to="/admin/transaksi/penetapan-biaya-eri">
                          Penetapan ERI
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.transaksi_pendaftaran == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Pendaftaran Lama")) &&
                      <Menu.Item key="pdftrn">
                        <Link to="/admin/transaksi/pendaftaran">
                          Pendaftaran Lama
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.transaksi_penetapan == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Penetapan")) &&
                      <Menu.Item key="jarak_tanam">
                        <Link to="/admin/transaksi/penetapan-biaya">
                          Penetapan
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}
                
                {(this.props.akses == null || (this.props.waktu_akses.is_bypass == true || (this.props.akses != undefined && this.props.akses.transaksi_pembayaran == true)) &&
                // {(this.props.akses == null || this.props.is_bypass == true ||(this.props.akses != undefined && this.props.akses.transaksi_pembayaran == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Pembayaran")) &&
                      <Menu.Item key="pembayaran">
                        <Link to="/admin/transaksi/pembayaran">
                          Pembayaran
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}
                {(this.props.akses == null || this.props.waktu_akses.is_bypass == true || (this.props.akses != undefined && this.props.akses.transaksi_surat_keterangan_fiskal == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Surat Keterangan Fiskal")) &&
                      <Menu.Item key="surat_fiskal">
                        <Link to="/admin/transaksi/surat-keterangan-fiskal">
                          Surat Keterangan Fiskal
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.transaksi_cancle_notice == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Batal Notice")) &&
                      <Menu.Item key="cancel_notice">
                        <Link to="/admin/transaksi/cancel-notice">
                          Batal Notice
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}

                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.transaksi_histori_notice == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Histori Notice")) &&
                      <Menu.Item key="histori_notice">
                        <Link to="/admin/transaksi/histori-notice">
                          Histori Notice
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}

                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.transaksi_koreksi_nomor_notice == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Koreksi Nomor Notice")) &&
                      <Menu.Item key="koreksi_nomor_notice">
                        <Link to="/admin/transaksi/koreksi-nomor-notice">
                          Koreksi Nomor Notice
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}

                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.transaksi_sinkron_notice == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Sinkronisasi Notice")) &&
                      <Menu.Item key="sinkron_notice">
                        <Link to="/admin/transaksi/sinkron-notice">
                          Sinkronisasi Notice
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}

                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.transaksi_audit_notice_rusak == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Audit Notice Rusak")) &&
                      <Menu.Item key="audit_notice_rusak">
                        <Link to="/admin/transaksi/audit-notice-rusak">
                          Audit Notice Rusak
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}

                {/* Jasaraharja, Validasi Setoran SWDKLLJ, SMDD, Cross Check SWDKLLJ
                    dipindah ke grup menu "Jasa Raharja" (2026-10-03) */}

                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.iwkbu == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "IWKBU")) &&
                      <Menu.Item key="iwkbu">
                        <Link to="/admin/transaksi/iwkbu">
                          IWKBU
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}

              </SubMenu>
            )}

            {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.jasa_raharja == true &&
              (this.state.cariMenu == "" ||
                this.cariMenu(this.state.cariMenu, "Jasa Raharja Resend Data IWKBU Golongan Transaksi JR Validasi Setoran SWDKLLJ SMDD Cross Check")
              )
            ) &&
              <SubMenu
                key="mn_jasa_raharja"
                title={
                  <span>
                    <SafetyCertificateOutlined />
                    <span>Jasa Raharja</span>
                  </span>
                }
              >

                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.jasa_raharja_resend == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Resend Jasa Raharja")) &&
                      <Menu.Item key="resend_jasa_raharja">
                        <Link to="/admin/jasa-raharja/resend">
                          Resend Jasa Raharja
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}

                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.master_iwkbu == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Data IWKBU")) &&
                      <Menu.Item key="data_iwkbu"><Link to="/admin/iwkbu">Data IWKBU</Link></Menu.Item>
                    }
                  </>
                )}

                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.master_golongan == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Golongan")) &&
                      <Menu.Item key="golongan"><Link to="/admin/golongan">Golongan</Link></Menu.Item>
                    }
                  </>
                )}

                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.transaksi_jasa_raharja == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Transaksi JR")) &&
                      <Menu.Item key="jasaraharja">
                        <Link to="/admin/transaksi/jasaraharja">
                          Transaksi JR
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}

                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.transaksi_validasi_setoran == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Validasi Slip Setoran")) &&
                      <Menu.Item key="validasi_setoran">
                        <Link to="/admin/transaksi/validasi-setoran">
                          Validasi Setoran SWDKLLJ
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}

                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.transaksi_smdd == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "SMDD")) &&
                      <Menu.Item key="smdd">
                        <Link to="/admin/transaksi/smdd">
                          SMDD
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}

                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.cross_check == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Cross Check")) &&
                      <Menu.Item key="cross_check">
                        <Link to="/admin/transaksi/uji-silang">
                          Cross Check SWDKLLJ
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}

              </SubMenu>
            )}

            {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.laporan == true &&
              (this.state.cariMenu == "" ||
                this.cariMenu(this.state.cariMenu, "laporan PNBP Kasir Perekening Pemutihan Cetak STNK Bendahara Penerimaan Bendahara PKB &amp; BBNKB Penetapan PKB &amp; BBNKB Penerimaan PKB Warna Plat STSS Harian SWDKLLJ Pengantar Penyetoran Uang Penerimaan BBNKB &amp; PKB Notice Notice Rusak Penggunaan Notice Overlap Kode Notice Tumpang Tindih")
              )
            ) &&
              <SubMenu
                key="mn_laporan"
                title={
                  <span>
                    <CopyOutlined />
                    <span>Laporan</span>
                  </span>
                }
              >

                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.laporan_pnbp == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "laporan PNBP")) &&
                      <Menu.Item key="lap_pnbp">
                        <Link to="/admin/laporan/pnbp">
                          PNBP
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}

                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.laporan_kasir == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "laporan Kasir")) &&
                      <Menu.Item key="lap_kasir">
                        <Link to="/admin/laporan/kasir">
                          Kasir
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}
                
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.laporan_teller == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "laporan Teller")) &&
                      <Menu.Item key="lap_teller">
                        <Link to="/admin/laporan/teller">
                          Penerimaan Teller
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}

                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.laporan_perekening == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "laporan Perekening")) &&
                      <Menu.Item key="lap_perekening">
                        <Link to="/admin/laporan/perekening">
                          Perekening
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}

                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.laporan_pemutihan == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "laporan Pemutihan")) &&
                      <Menu.Item key="lap_pemutihan">
                        <Link to="/admin/laporan/pemutihan">
                          Pemutihan
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}

                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.laporan_cetak_stnk == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "laporan Cetak STNK")) &&
                      <Menu.Item key="lap_cetak_stnk">
                        <Link to="/admin/laporan/cetak-stnk">
                          Cetak STNK
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.laporan_bendahara_penerimaan == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "laporan Bendahara Penerimaan")) &&
                      <Menu.Item key="lap_bendahara_pnerimaan">
                        <Link to="/admin/laporan/bendahara-penerimaan">
                          Bendahara Penerimaan
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.laporan_bendaraha_pkb_bbnkb == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "laporan Bendahara PKB &amp; BBNKB")) &&
                      <Menu.Item key="lap_bendahara_pkb">
                        <Link to="/admin/laporan/bendahara-pkb">
                          Bendahara PKB &amp; BBNKB
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}

                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.laporan_penetapan_pkb_bbnkb == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "laporan Penetapan PKB &amp; BBNKB")) &&
                      <Menu.Item key="lap_harian_pkb">
                        <Link to="/admin/laporan/harian-pkb">
                          Penetapan PKB &amp; BBNKB
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}

                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.laporan_penerimaan_pkb_plat == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "laporan Penerimaan PKB Warna Plat")) &&
                      <Menu.Item key="lap_pkb_warna">
                        <Link to="/admin/laporan/penerimaan-pkb-warna">
                          Penerimaan PKB Warna Plat
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}

                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.laporan_sum32 == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "laporan Penerimaan PKB Warna Plat")) &&
                      <Menu.Item key="lap_sum_32">
                        <Link to="/admin/laporan/sum-32">
                          SUM 32
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}

                {/* {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.laporan_sts == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "laporan STSS")) &&
                      <Menu.Item key="lap_stss">
                        <Link to="/admin/laporan/stss">
                          STS
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )} */}

                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.laporan_sts == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "laporan STS Harian")) &&
                      <Menu.Item key="lap_stss_harian">
                        <Link to="/admin/laporan/sts-harian">
                          STS Harian
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}

                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.laporan_swdkllj == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "laporan SWDKLLJ")) &&
                      <Menu.Item key="lap_swdkllj">
                        <Link to="/admin/laporan/swdkllj">
                          SWDKLLJ
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}

                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.penyetoran_uang == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "laporan Pengantar Penyetoran Uang")) &&
                      <Menu.Item key="lap_penyet_uang">
                        <Link to="/admin/laporan/penyetoran-uang">
                          Pengantar Penyetoran Uang
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}

                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.laporan_penerimaan_bbnkb_pkb == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "laporan Penerimaan BBNKB &amp; PKB")) &&
                      <Menu.Item key="lap_bbnkb">
                        <Link to="/admin/laporan/bbnkb-pkb">
                          Penerimaan BBNKB &amp; PKB
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.laporan_notice == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "laporan Notice")) &&
                      <Menu.Item key="lap_notice">
                        <Link to="/admin/laporan/notice">
                          Notice
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.laporan_notice_rusak == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "laporan Notice Rusak")) &&
                      <Menu.Item key="lap_notice_rusak">
                        <Link to="/admin/laporan/notice-rusak">
                          Notice Rusak
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}

                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.laporan_penggunaan_notice_rusak == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "laporan Penggunaan Notice Notice Rusak")) &&
                      <Menu.Item key="lap_penggunaan_notice_rusak">
                        <Link to="/admin/laporan/penggunaan-notice-rusak">
                          Penggunaan Notice
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.laporan_overlap_notice == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "laporan Overlap Kode Notice Tumpang Tindih")) &&
                      <Menu.Item key="lap_overlap_notice">
                        <Link to="/admin/laporan/overlap-notice">
                          Overlap Kode Notice
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.laporan_duplikat_nopol_aktif == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "laporan Duplikat Nopol Aktif")) &&
                      <Menu.Item key="lap_duplikat_nopol_aktif">
                        <Link to="/admin/laporan/duplikat-nopol-aktif">
                          Duplikat Nopol Aktif
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.laporan_audit_nik == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "laporan Audit NIK")) &&
                      <Menu.Item key="lap_audit_nik">
                        <Link to="/admin/laporan/audit-nik">
                          Audit NIK
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}
                {(this.props.level_user === 1 || this.props.akses == null || (this.props.akses != undefined && this.props.akses.laporan_ba_batal_skpd == true)) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "laporan BA Batal SKPD Berita Acara")) &&
                      <Menu.Item key="lap_ba_batal_skpd">
                        <Link to="/admin/laporan/ba-batal-skpd">
                          BA Batal SKPD
                        </Link>
                      </Menu.Item>
                    }
                  </>
                }
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.laporan_status_printer == true)) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "laporan Status Printer Monitoring Heartbeat")) &&
                      <Menu.Item key="lap_status_printer">
                        <Link to="/admin/laporan/status-printer">
                          Status Printer
                        </Link>
                      </Menu.Item>
                    }
                  </>
                }
              </SubMenu>
            )}

            {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.analitik == true &&
              (this.state.cariMenu == "" ||
                this.cariMenu(this.state.cariMenu, "analitik Proyeksi Potensi PKB") ||
                this.cariMenu(this.state.cariMenu, "analitik Tunggakan Kendaraan") ||
                this.cariMenu(this.state.cariMenu, "analitik List Tunggakan"))
            )
            ) &&
              <SubMenu
                key="mn_analitik"
                title={
                  <span>
                    <LineChartOutlined />
                    <span>Analitik</span>
                  </span>
                }
              >
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.analitik_proyeksi_potensi_pkb == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "analitik Proyeksi Potensi PKB")) &&
                      <Menu.Item key="analitik_proyeksi_potensi_pkb">
                        <Link to="/admin/analitik/proyeksi-potensi-pkb">
                          Proyeksi Potensi PKB
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.analitik_tunggakan == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "analitik Tunggakan Kendaraan")) &&
                      <Menu.Item key="analitik_tunggakan">
                        <Link to="/admin/analitik/tunggakan">
                          Tunggakan Kendaraan
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.analitik_list_tunggakan == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "analitik List Tunggakan")) &&
                      <Menu.Item key="analitik_list_tunggakan">
                        <Link to="/admin/analitik/list-tunggakan">
                          List Tunggakan
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}
              </SubMenu>
            }

            {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.secrets == true &&
              (this.state.cariMenu == "" ||
                this.cariMenu(this.state.cariMenu, "API Key") ||
                this.cariMenu(this.state.cariMenu, "Konfigurasi App Cetak"))
            )
            ) &&
              <SubMenu
                key="mn_secrets"
                title={
                  <span>
                    <LockOutlined />
                    <span>Pengaturan Secrets</span>
                  </span>
                }
              >
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.secrets_apikey == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "API Key")) &&
                      <Menu.Item key="secrets_apikey">
                        <Link to="/admin/secrets/apikey">
                          API Key
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}
                {(this.props.akses == null || (this.props.akses != undefined && this.props.akses.secrets_print_client_config == true) &&
                  <>
                    {(this.state.cariMenu == "" || this.cariMenu(this.state.cariMenu, "Konfigurasi App Cetak")) &&
                      <Menu.Item key="secrets_print_client_config">
                        <Link to="/admin/secrets/konfigurasi-app-cetak">
                          Konfigurasi App Cetak
                        </Link>
                      </Menu.Item>
                    }
                  </>
                )}
              </SubMenu>
            }

          </Menu>
          </PerfectScrollbar>

          {/* Bottom: Papan Pengumuman + User Aktif + User */}
          <div className="sider-bottom">
            {/* Notifikasi Batal Notice — hanya Kasi Penetapan */}
            {this.props.akses && this.props.akses.transaksi_cancle_notice_approve && (
              <Tooltip title={this.props.collapsed ? 'Permintaan Batal Notice' : ''} placement="right">
                <div
                  className="sider-bottom-item"
                  onClick={() => this.props.setConfig({ openCancelNoticeNotif: true })}
                >
                  <Badge
                    count={this.props.cancelNoticePendingCount || 0}
                    size="small"
                    offset={[-2, 2]}
                    style={{ backgroundColor: '#ff4d4f', boxShadow: '0 0 0 1px #0f2847' }}
                  >
                    <BellOutlined className="sider-bottom-icon" style={{ color: '#ff7a45' }} />
                  </Badge>
                  {!this.props.collapsed && (
                    <span className="sider-bottom-label">Batal Notice</span>
                  )}
                </div>
              </Tooltip>
            )}

            {/* Papan Pengumuman DIHAPUS dari sidebar - sudah ada ikon speaker
                di topbar (AdminHeader.jsx) yang fungsinya sama, biar tidak
                dobel. Lihat diskusi 2026-10-17. */}

            {/* User Aktif — hanya level 1 & 2 */}
            {(this.props.level_user != null && this.props.level_user <= 2) && (
              <Tooltip title={this.props.collapsed ? `User Aktif (${this.props.activeUsersCount || 0})` : ''} placement="right">
                <div
                  className="sider-bottom-item"
                  onClick={() => this.props.setConfig({ openUserAktifPanel: true })}
                >
                  <Badge
                    count={this.props.activeUsersCount || 0}
                    size="small"
                    offset={[4, 0]}
                    style={{ backgroundColor: '#34d399', fontSize: 10 }}
                  >
                    <TeamOutlined className="sider-bottom-icon" style={{ color: '#34d399' }} />
                  </Badge>
                  {!this.props.collapsed && <span className="sider-bottom-label">User Aktif</span>}
                </div>
              </Tooltip>
            )}

            <div className="sider-bottom-divider" />

            <Tooltip title={this.props.collapsed ? (this.props.nama || this.props.username) : ''} placement="right">
              <div className="sider-bottom-item sider-bottom-user-row">
                <Avatar
                  size={26}
                  src={this.props.pp && !this.props.pp.endsWith('user.png') ? this.props.pp : undefined}
                  style={{ background: '#1e4d8a', flexShrink: 0, fontSize: 11 }}
                >
                  {(!this.props.pp || this.props.pp.endsWith('user.png'))
                    ? (this.props.nama ? this.props.nama[0].toUpperCase() : <UserOutlined />)
                    : null}
                </Avatar>
                {!this.props.collapsed && (
                  <>
                    <Link to="/admin/profil" className="sider-bottom-name">
                      {this.props.nama || this.props.username}
                    </Link>
                    <Tooltip title="Logout" placement="top">
                      <LogoutOutlined className="sider-logout-btn" onClick={this.handleLogout} />
                    </Tooltip>
                  </>
                )}
                {this.props.collapsed && (
                  <LogoutOutlined className="sider-logout-btn" onClick={this.handleLogout} style={{ marginLeft: 'auto' }} />
                )}
              </div>
            </Tooltip>
          </div>
        </Sider>
      </>
    )
  }
}

const mapStateToProps = function (state) {
  return state.configReducers
}

export default connect(mapStateToProps, { setConfig, ajaxViewHandler })(AdminSider);
